import { useSelector } from 'react-redux'

export const useLocale = () => useSelector(state => (state as any).i18n.locale)
